<template>
  <el-popover
    placement="right-end"
    trigger="hover"
    :style="!showBoardHandle && !$store.state.menu.collapse ? 'width:100%' : ''"
  >
    <div style="padding: 12px 12px 0">
      <template v-for="menu in menuList">
        <div class="directory" v-for="dict in menu.children" :key="dict.name" style="max-width: 420px">
          <template v-if="dict.children">
            <div class="title">
              {{ $t('menu::' + dict['actionCode'].split('::').slice(1).join('::')) }}
            </div>
            <div class="menuList">
              <div
                v-for="item in dict.children"
                @click="toUrl(item)"
                :key="item.actionCode"
                class="menu"
                :class="dict.name.split('::').slice(0)"
              >
                <img class="menuIcon" :src="getImage(item.icon)" v-if="getImage(item.icon)" />
                <i class="iconfont" :class="item.icon" v-else></i>
                <span>
                  {{ $t('menu::' + item['actionCode'].split('::').slice(1).join('::')) }}
                </span>
              </div>
            </div>
          </template>
        </div>
      </template>
    </div>

    <el-button
      class="menu-button self-btn"
      type="primary"
      plain
      size="medium"
      slot="reference"
      :class="{ 'collapse-menu-button': $store.state.menu.collapse }"
      :style="!showBoardHandle ? 'width:100%' : 'margin-left:5px;'"
    >
      <!-- <i class="iconfont icona-06caidan"></i> -->
      <img :src="menus" style="width: 24px; display: inline-block" />
    </el-button>
  </el-popover>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    showBoardHandle: {
      type: Boolean,
      default: false,
    },
    menuList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      menus: require('@/assets/images/layout/menu.png'),
    }
  },
  methods: {
    getImage(icon) {
      let imgList = require.context(`@/assets/images/menu`, true, /\.png$/)
      let img = []
      imgList.keys().forEach(fileName => {
        let comp = imgList(fileName)
        img[fileName.split('.png')[0].slice(2)] = comp
      })
      if (img[icon]) {
        return img[icon]
      } else {
        return null
      }
    },
    toUrl(item) {
      if (item.url) {
        this.$router.push({ path: item.url })
      } else {
        this.$router.push({ name: item.actionCode.split('::').pop() })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.dict {
  background: #f7f8fa;
  border-radius: 14px;
  padding: 6px 14px;

  font-size: 13px !important;
  font-weight: normal;
  color: #54627c;
}
.icondown-circle-01 {
  font-size: 13px;
}
.directory {
  .title {
    color: #999;
    // font-weight: bold;
    font-size: 12px;
    // margin-bottom: 16px;
  }
  .menuList {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    transform: translate(-12px, 0);
    .menu {
      // background: #fffbf1;
      //   padding: 16px;
      margin-left: 16px;
      width: 80px;
      height: 80px;
      cursor: pointer;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-bottom: 12px;
      .iconfont {
        font-size: 22px !important;
        margin-bottom: 8px;
      }
      .menuIcon {
        width: 28px;
        margin-bottom: 8px;
      }
      span {
        font-size: 12px;
        color: #273645;
      }
    }
    .shop-data {
      // background: rgba(54, 109, 255, 0.05);
      .iconfont {
        color: #0560fd !important;
      }
    }
    .system-set {
      // background: #f4fcf9;
      .iconfont {
        color: #05c46d !important;
      }
    }
    .param-setting {
      // background: #fffbf1;
      .iconfont {
        color: #fca315 !important;
      }
    }
  }
}
.directory + .directory {
  padding-top: 16px;
  border-top: 1px solid #f5f5f5;
}
.menu-button {
  border: 0px;
  padding: 11px 6px;
  border-radius: 8px;
  &.self-btn {
      width: 54px;
  }
}
.collapse-menu-button {
  padding: 10px !important;
  margin: 0 !important;
}
</style>
